import React, {Component} from 'react';
import FieldsFactory from '../../ui_core/fieldsFactory';
import Error from '../../ui_core/message/errors';
import Normal from '../../ui_core/message/normal';
import config from '../../config';


class TestSend extends Component {
    constructor(props) {
        super(props);
        this.control = {
            onChange:      this.onChange.bind(this),
        };
        this.getData = this.props.props.tools.getData.bind(this);
        this.state = {
            message: {
                error: '',
                text:  '',
            },
            values:  [],
        };
        this.resetMessage = this.resetMessage.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange(data) {
        this.setState({
            ...this.state,
            values: data.target.value,
        });
    }

    componentDidMount() {
        this.getData('/test-send/get')
            .then((data) => {
                const emails = data.map((item) => item.emailAddress);

                this.setState({
                    ...this.state,
                    values: emails || [],
                });
            });
    }

    async errorCheck(response) {
        const getJSON = async (response) => {
            return await response.json().then(jsonData => jsonData);
        };
        let res;
        let message;

        res = response;
        if (response.body) {
            res = await getJSON(response);
        }
        message = {
            error: [
                       'Status: ' + (response.status || response.name),
                       res.error || '',
                       response.statusText || '',
                       res.message || '',
                   ].join('<Br/>'),
        };

        this.setState({
            message,
        });

        throw new Error(message);
    }

    sendData() {
        const headers = new Headers({
            'Content-Type': 'application/json',
        });
        const data = {
            method:      'POST',
            headers:     headers,
            body:        JSON.stringify(this.state.values),
            credentials: 'include',
        };

        return fetch(config.endpoint + '/test-send/update' + window.location.search, data)
            .then(res => res.json())
            .catch(async (response) => {
                this.errorCheck(response);
            });
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.state.values) {
            this.sendData()
                .then((response) => {
                    if (response.error) {
                        this.errorCheck(response);
                    } else {
                        this.setState({
                            ...this.state,
                            message: {
                                error: '',
                                text:  response.status === 'ok' ? 'Done!' : '',
                            },
                        });
                    }
                });
        }
    }

    resetMessage() {
        this.setState({
            ...this.state,
            message: {
                error: '',
                text:  '',
            },
        });
    }

    render() {
        return (
            <div>
                <div className="defaultWrapper">
                    <form>
                        {this.state.message.error ? <Error error={this.state.message.error}/> : ''}
                        {this.state.message.text ?
                            <Normal removeMessage={this.resetMessage} message={this.state.message.text}/> : ''}
                        <div className="wrapper_row">
                            <div className="right-col block">
                                <FieldsFactory title="Test send contacts"
                                               {...this.control}
                                               type="list"
                                               value={this.state.values}
                                />
                            </div>
                        </div>
                        <div className="wrapper_row right-align">
                            <div className="btn-wrapper">
                                <button className="btn btn-primary"
                                        onClick={this.onSubmit}>
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default TestSend;